"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = require("styled-components");
const oxygen_config_1 = require("@8x8/oxygen-config");
const themeName_1 = __importDefault(require("../constants/themeName"));
const colorTypes_1 = require("../constants/colorTypes");
const TabsBar_1 = __importDefault(require("../styled/TabsBar"));
const Tabs = ({ theme, children, forwardedRef, ...otherProps }) => {
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(TabsBar_1.default, { role: "tablist", ref: forwardedRef, ...otherProps }, children)));
};
Tabs.propTypes = {
    children: prop_types_1.default.node.isRequired,
    theme: prop_types_1.default.object,
    color: prop_types_1.default.oneOf([colorTypes_1.DARK, colorTypes_1.LIGHT]),
};
Tabs.defaultProps = {
    theme: {},
    color: colorTypes_1.LIGHT,
};
exports.default = (0, oxygen_config_1.withTheme)(Tabs, themeName_1.default);
